import { render } from "./Prioritizing_issueById.vue?vue&type=template&id=236dbed7&scoped=true"
import script from "./Prioritizing_issueById.vue?vue&type=script&lang=js"
export * from "./Prioritizing_issueById.vue?vue&type=script&lang=js"

import "./Prioritizing_issueById.vue?vue&type=style&index=0&id=236dbed7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236dbed7"]])

export default __exports__